import { AddPageButton } from "./AddPageButton";

export const AddPageButtonContainer = AddPageButton;

export { AddPageButtonContainer as AddPageButton };
